module.exports = __webpack_public_path__ + "img/4.03b23af9.png";